import type { ComparisonValue } from '@epilot/journey-logic-commons/src/types/next'
import { LOGIC_OPERATOR } from '@epilot/journey-logic-commons/src/types/next'
import { z } from 'zod'

import { Operator } from '../operator'

export class ContainEither extends Operator<unknown[]> {
  constructor() {
    super(LOGIC_OPERATOR.CONTAIN_EITHER, z.unknown().array())
  }

  evaluate(factValue: unknown[], comparisonValue: ComparisonValue): boolean {
    if (Array.isArray(comparisonValue)) {
      return comparisonValue.some(
        (_comparisonValue) => factValue.indexOf(_comparisonValue) > -1
      )
    }

    return false
  }
}
